<template>
  <div dense flat class="custom__toolbar mb-5 d-flex">
    <v-spacer />
    <v-btn
      v-if="isAdmin || isDataEntry || isDataEntryAndDispatcher"
      @click="$router.push('/templates/create')"
      outlined
      depressed
      color="primary"
      tile
    >
      <v-icon left>
        mdi-plus
      </v-icon>
      <span>
        ADD TEMPLATES
      </span>
    </v-btn>
  </div>
</template>

<script>
export default {
  components: {}
};
</script>

<style lang="scss">
.session-toolbar {
  .v-toolbar__content {
    padding: 0px !important;
  }
}
</style>
